import type { ReportRow, ReportSummary } from 'src/app/core/services/reports-api.service';

export type OutcomeKey = 'pass' | 'review' | 'fail';

export interface OutcomeChip {
  key: OutcomeKey;
  count: number;
  label: string;
  tooltip: string;
  cls: string;
}

const OUTCOMES = [
  { key: 'pass', field: 'pass_count', label: 'Pass', noun: 'passed', cls: 'bg-success/20 text-success' },
  { key: 'review', field: 'review_count', label: 'Review', noun: 'need review', cls: 'bg-warning/20 text-warning' },
  { key: 'fail', field: 'fail_count', label: 'Fail', noun: 'failed', cls: 'bg-danger/20 text-danger' },
] as const;

/** True once the backend sends counts at all (a zero still counts); false against an older backend. */
export function hasOutcomeData(row: ReportRow): boolean {
  return OUTCOMES.some((o) => typeof row[o.field] === 'number');
}

/** The non-zero outcomes of one agent, in pass / review / fail order. */
export function outcomeChips(row: ReportRow): OutcomeChip[] {
  const chips: OutcomeChip[] = [];
  for (const o of OUTCOMES) {
    const count = row[o.field] ?? 0;
    if (count > 0) chips.push({ key: o.key, count, label: o.label, tooltip: `${count} ${o.noun}`, cls: o.cls });
  }
  return chips;
}

/** PDs that are in no outcome bucket (no final result yet), so the tiles never imply a total they lack. */
export function unscoredCount(summary: ReportSummary | null | undefined): number {
  if (!summary) return 0;
  return Math.max(0, summary.total_pds - (summary.pass_count + summary.review_count + summary.fail_count));
}
